import React from 'react'

import Text from './Text'
import { primaryTextColor, errorColor } from './colors'

const LABEL_COLOR = {
  default: primaryTextColor,
  error: errorColor,
}

const Label = ({ size, value, type = 'default', style }) => {
  const color = LABEL_COLOR[type]
  return (
    <Text size={size} color={color} style={style}>
      {value}
    </Text>
  )
}

export default Label
